<template>
  <div id="container">空调系统</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
#container {
  height: 100%;
}
</style>